export default "__VITE_ASSET__cICwBOUG__"